import { render, staticRenderFns } from "./created-time.vue?vue&type=template&id=2325bd26&"
import script from "./created-time.vue?vue&type=script&lang=js&"
export * from "./created-time.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports